import { InvestorCaseWizard } from "./InvestorCaseWizard";
import { InvestorWizardProvider } from "./InvestorCaseWizard/context";

export const InvestorCaseNavigation = () => (
  <InvestorWizardProvider>
    <InvestorCaseWizard />
  </InvestorWizardProvider>
);
